import {
  DELETE_IMAGES,
  SET_ACTION_MODE,
  SET_SUBMITTING,
  SET_QUESTION_OPTIONS,
  SET_CHANGED_OPTIONS,
  ADD_IMAGE,
  SET_IMAGES,
  ADD_NON_STANDARD_IMAGE,
  SET_NON_STANDARD_IMAGES,
  SET_ADDITIONAL_IMAGES,
  SET_FILES_TO_UPLOAD,
} from '../constants/actionTypes';

const initialState = {
  isActionMode: false,
  isSubmitting: false,
  options: {},
  changedOptions: [],
  images: [],
  nonStandardImages: [],
  addImages: [],
  filesToUpload: 0,
};

const form = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTION_MODE:
      return {...state, isActionMode: action.payload};
    case SET_SUBMITTING:
      return {...state, isSubmitting: action.payload};
    case SET_QUESTION_OPTIONS:
      return {...state, options: {...state.options, [action.payload.field]: action.payload.options }};
    case SET_CHANGED_OPTIONS:
      return {...state, changedOptions: action.payload};
    case ADD_IMAGE:
      return {...state, images: state.images.concat(action.payload)};
    case ADD_NON_STANDARD_IMAGE:
      return {...state, nonStandardImages: state.nonStandardImages.concat(action.payload)};
    case SET_IMAGES:
      return {...state, images: action.payload};
    case SET_NON_STANDARD_IMAGES:
      return {...state, nonStandardImages: action.payload};
    case DELETE_IMAGES:
      return {...state, images: [], nonStandardImages: []};
    case SET_ADDITIONAL_IMAGES:
      return {...state, addImages: action.payload};
    case SET_FILES_TO_UPLOAD:
      return {...state, filesToUpload: action.payload === '+' ? state.filesToUpload + 1 : state.filesToUpload - 1}
    default:
      return state;
  }
};

export default form;



// WEBPACK FOOTER //
// ./src/reducers/reducer-form.js